var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.value),function(el){return _c('LinkDetail',_vm._b({key:el.key,attrs:{"row":_vm.row}},'LinkDetail',el,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }